module.exports = __webpack_public_path__ + "static/img/hyundai-font-text@w.349015f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/hyundai-font-text@w.png
// module id = +pBd
// module chunks = 0